import type { PortfolioMenuItemSelection } from '$lib/types/home';

export const OPENSEA_NFT_URL =
	'https://opensea.io/assets/optimism/0x7fD2746f20F2EDD69f121f985620d3af84297aff';

export const orbTypeToNameMap = {
	NORMAL: 'Normal Orb',
	RARE: 'Rare Orb',
	LEGENDARY: 'Legendary Orb'
};

export const orbContentTypeToNameMap = {
	POLY_POINTS: 'Points'
	// TODO: Add more types here
};

export const levelDescriptionsArray = [
	'Claim Lvl 1 Badge and get special discord role.',
	'Took your first step? Time to climb the ranks and get more rewards this season.',
	'Reach level 3 to be eligible for a cool NFT and rare mystery orbs.',
	'Trade more and earn more rewards in the mystery boxes to come on level 4.',
	'Want to know about legendary mystery orbs? Climb the ranks and reach level 5.',
	'Some of the most exciting rewards are waiting for you in the next level!',
	'Almost there, trade more and reach the final level and become one of our top traders.'
];

export const numberOfLevelUsersIcons = ['🎯', '🎯', '👒', '🧣', '💍', '💎', '🎩', '🔱'];

export const orbTweetContent =
	"text=I just got a mystery orb from @PolynomialFi! %0a%0aI wonder what's inside? %0a%0aGo check yours at https://trade.polynomial.fi/mystery-orbs";
export const noMysteryOrbTweetContent =
	"text=Faded @PolynomialFi in 2023 😨 %0a%0aBut this time, it's different. %0a%0aStart trading today ⚡️";

export const queryStringToTabMap: Record<string, PortfolioMenuItemSelection> = {
	dashboard: 'Dashboard',
	levels: 'Levels',
	leaderboard: 'Leaderboard',
	'mystery-orbs': 'Mystery Orbs',
	activity: 'Activity'
};
